// src/api/fetchWithAuth.js
import { refreshAccessToken } from "./auth";

export async function fetchWithAuth(url, options = {}) {
  // Получаем текущий access_token и время его истечения из localStorage
  let token = localStorage.getItem("access_token");
  const expirationTime = Number(localStorage.getItem("access_expiration_time")); // хранится в секундах
  const currentTime = Math.floor(Date.now() / 1000); // текущее время в секундах
  console.log('expirationTime', expirationTime)
  console.log(currentTime)

  // Если до истечения токена осталось менее 5 минут (300 секунд), обновляем его
  if (expirationTime && (expirationTime - currentTime < 300)) {
    console.log("Осталось мало времени до истечения токена, обновляем...");
    try {
      token = await refreshAccessToken();
    } catch (error) {
      console.error("Ошибка обновления токена перед запросом:", error);
      throw new Error("Не удалось обновить токен перед запросом: " + error.message);
    }
  }

  // Формируем заголовки запроса с актуальным токеном
  const headers = {
    "Content-Type": "application/json",
    "Authorization": token ? `Bearer ${token}` : "",
    ...options.headers,
  };

  // Выполняем исходный запрос
  let response = await fetch(url, { ...options, headers });
  console.log(`Запрос ${url} вернул статус ${response.status}`);

  // Если получен 401 Unauthorized, пробуем обновить токен и повторить запрос
  if (response.status === 401) {
    console.log("Получен 401 Unauthorized, пытаемся обновить токен...");
    try {
      token = await refreshAccessToken();
      headers["Authorization"] = `Bearer ${token}`;
      response = await fetch(url, { ...options, headers });
      console.log("Повторный запрос выполнен, статус:", response.status);
    } catch (error) {
      console.error("Ошибка обновления токена после 401:", error);
      // Если обновление не удалось — очищаем данные и выбрасываем ошибку
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("access_expiration_time");
      throw new Error("Unauthorized: Token refresh failed");
    }
  }

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
}
